/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges, OnInit} from '@angular/core';

import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {APP_SHARED} from '../common/app-shared';

@Component({
  standalone: true,
  imports: [...APP_SHARED, TranslateModule],
  selector: 'line-item-status-explanation-label',
  template: `<span *ngIf="adjustedState">{{ "lineItem.userState.explanation." + adjustedState | translate }}</span>`
})
export class LineItemStatusExplanationLabelComponent implements OnInit, OnChanges {
  @Input() userState: string;
  @Input() isMarketplace: string;
  adjustedState: string;

  constructor(public translate: TranslateService) {
  }

  ngOnChanges() {
    this.updateValues();
  }

  ngOnInit(): void {
    this.updateValues();
  }

  private updateValues() {
    this.adjustedState = this.userState;
    if (this.userState === 'PAUSED' && this.isMarketplace) {
      this.adjustedState += "Marketplace";
    }
  }
}
